<template>
  <div>
    <TituloDialog />

    <TempleteConteudoDialog class="text-center d-flex justify-center align-center">
      <ProgressoCarregamentoFase v-if="carregando_dados" />

      <div v-show="!carregando_dados">
        <IconePastasDeArquivos />

        <p id="decricao" class="mb-6" v-text="'Faça o upload dos arquivos para começar'" />

        <CarregadorDeArquivosInput
          @carregando_dados="carregando_dados = $event"
          @cotacoes-para-analisar="$emit('cotacoes-para-analisar', $event);() => alert(9)"
        />
      </div>
    </TempleteConteudoDialog>

    <RodapeDialog @cancelar="cancelar" />
  </div>
</template>

<script>
import TempleteConteudoDialog from "../ajudantes/TempleteConteudoDialog.vue";
import CarregadorDeArquivosInput from "./CarregadorDeArquivosInput.vue";
import TituloDialog from "../TituloDialog.vue";
import RodapeDialog from "../RodapeDialog.vue";
import ProgressoCarregamentoFase from "../ProgressoCarregamentoFase.vue";
import IconePastasDeArquivos from "../../../../utils/icones/PastasDeArquivos.vue";

export default {
  name: "CarregandoArquivos",
  components: {
    TempleteConteudoDialog,
    CarregadorDeArquivosInput,
    TituloDialog,
    RodapeDialog,
    ProgressoCarregamentoFase,
    IconePastasDeArquivos
  },
  data: () => ({
    carregando_dados: false
  }),
  methods: {
    cancelar() {
      this.carregando_dados = false;
      this.$emit("fechar-dialog", {});
    }
  }
}
</script>

<style scoped>
#decricao {
  font-size: 24px;
  color: #142454;
  line-height: 24px;
  margin: 16px 0;
}
</style>
